import type { UserArticle_UserPageFragment } from "__generated__/jampot/alpha-kr";
import { FleamarketArticleStatus } from "__generated__/jampot/alpha-kr";
import { Flex } from "@daangn/carotene";
import type { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import { isMemberOfEnum } from "@karrotmarket-com/type-utility";
import { isNil } from "lodash";

import SquareThumbnailCard from "~/figma-components/SquareThumbnailCard";
import { Link } from "~/remix-lib";
import getFleamarketArticlePrice from "~/utils/getFleamarketArticlePrice";
import { shouldUseH3LocationName } from "~/utils/shouldUseH3LocationName";

import { getArticleThumbnail } from "../buy-sell/utils/articleImages";

const ThumbnailCardItemFromArticle: React.FC<{
  article: UserArticle_UserPageFragment;
  countryCode: KarrotLocalCountryCode;
}> = ({ article, countryCode }) => {
  if (article.status === FleamarketArticleStatus.Closed) {
    return null;
  }

  const thumbnail = getArticleThumbnail({
    thumbnail: article.thumbnail,
    category: article.category,
  });

  if (isNil(thumbnail)) {
    return null;
  }

  const item = {
    image: thumbnail,
    regionName: shouldUseH3LocationName(countryCode)
      ? article.locationName?.name ?? ""
      : article.regionId.name,
    subTitle: getFleamarketArticlePrice(countryCode, article.price),
    title: article.title,
    status: isMemberOfEnum(article.status, FleamarketArticleStatus)
      ? article.status
      : undefined,
  };

  return (
    <Link href={article.id} key={article.id}>
      <Flex flexDirection="row" width="full">
        <SquareThumbnailCard {...item} flex1 />
      </Flex>
    </Link>
  );
};

export default ThumbnailCardItemFromArticle;
